import { isNumber } from "./get-type";
export const transformNumToLetter = function (number: number): string {
  if (!isNumber(number)) return "";
  const A = 65;
  //   const Z = 90;
  const SUM = 26;
  const res_arr = [];
  let F = true;

  while (F || number !== 0) {
    F = false;
    res_arr.push(number % SUM);
    number = Math.floor(number / SUM);
  }
  return res_arr
    .reverse()
    .map((num) => String.fromCharCode(A + num))
    .join("");
};
